<template>
<section class="projects">
  <div class="container">
    <div class="projects-top">
      <h2>Наши проекты</h2>
    </div>
    <div class="projects-middle">
      <div class="row">
        <SectionProjectsItem
            v-for="item in projectsList"
            v-bind:item = "item"
        />
      </div>
    </div>
  </div>
</section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import SectionProjectsItem from "@/components/SectionProjectsItem";
export default {
  name: 'SectionProjects',
  components: {
    SectionProjectsItem,
  },
  methods: {
    ...mapActions(['viewProjectsRes']),
    resetView () {
      this.viewProjectsRes()
    }
  },
  computed: {
    ...mapGetters([
        'projectsList',
    ])
  },
  mounted() {
  },
  beforeDestroy() {
    this.resetView()
  }
}
</script>

<style scoped lang='scss'>
.projects {
  background-color: #eee;
  padding: 45px 0 0 0;
  @media (max-width: 575.98px) {
    padding: 20px 0 0 0;
  }
  .row {
    display: flex;
    padding-top: 50px;
    flex-wrap: wrap;
  }
}
</style>
